///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../../../baseClasses/dataMaintenance.interface.ts"/>
///<reference path="../../../../plugins/reports/reports.models.ts"/>
///<reference path="../common/collection-api.ts"/>


module Meevo.Components.Controls.SmartMover {
    import PurchaseOrderStateEnum = Meevo.Model.PurchaseOrderStateEnum;
    import IReportPurchaseOrder = Meevo.Plugins.Reports.IReportPurchaseOrder;

    interface ICriteria {
        StartDate: Date;
        EndDate: Date;
        PurchaseOrderStateEnumList_Tbl: PurchaseOrderStateEnum[];
    }

    export class ReportPurchaseOrdersCollection extends SmartMoverApiCollection<IReportPurchaseOrder> implements IApiCollection<IReportPurchaseOrder> {

        protected get url() {
            return 'report/PurchaseOrder';
        }

        protected criteriaIsValid() {
            const criteria = this.criteria as ICriteria;

            return !(!criteria.StartDate || !criteria.EndDate || !criteria.PurchaseOrderStateEnumList_Tbl);
        }
    }

}